export default function () {
  return {
    apiusers: [],
    apiusersCurrentPage: 1,
    apiusersLastPage: 1,
    apiusersPerPage: 0,
    apiusersTotal: 0,
    apiusersLoading: false,
    indexPage: null
  }
}
